import {
  AdviceProductDetailsFormValues,
  WorkSituation,
} from "../../../ProductDetails/FormElements/interfaces";

import { OneTimePaymentAdvisorChoice } from "../interfaces";
import { AdviceRestrictions } from "../utils";

export const OTP_MIN = 400000;
const OTP_MAX_ADVISOR = 2000000;

export const isWithinValidOtpRange = (
  twoTimesIncome: number,
  value: number,
  restrictions: AdviceRestrictions,
): boolean =>
  value >= OTP_MIN &&
  value <= restrictions.maxProductManager &&
  value <= twoTimesIncome;

const getCorrectOTPValueBasedOnChoice = (
  oneTimePaymentValue: number,
  advisorValueNumber: number,
  advisorChoice?: OneTimePaymentAdvisorChoice,
): number => {
  switch (advisorChoice) {
    case OneTimePaymentAdvisorChoice.ADVICED_ONE_TIME_PAYMENT:
      return oneTimePaymentValue;
    case OneTimePaymentAdvisorChoice.CUSTOM_ONE_TIME_PAYMENT:
      return advisorValueNumber;
    case OneTimePaymentAdvisorChoice.NO_ONE_TIME_PAYMENT:
    default:
      return 0;
  }
};

export const hasExceededMaxValueForNormalAdvisor = (
  oneTimePaymentValue: number,
  advisorValueNumber: number,
  restrictions: AdviceRestrictions,
  advisorChoice?: OneTimePaymentAdvisorChoice,
): boolean => {
  const value = getCorrectOTPValueBasedOnChoice(
    oneTimePaymentValue,
    advisorValueNumber,
    advisorChoice,
  );
  return value > OTP_MAX_ADVISOR && value <= restrictions.maxAuthorizedAdvisor;
};

export const hasExceededMaxValueForAuthorizedAdvisor = (
  oneTimePaymentValue: number,
  advisorValueNumber: number,
  restrictions: AdviceRestrictions,
  advisorChoice?: OneTimePaymentAdvisorChoice,
): boolean => {
  const value = getCorrectOTPValueBasedOnChoice(
    oneTimePaymentValue,
    advisorValueNumber,
    advisorChoice,
  );
  return (
    value > restrictions.maxAuthorizedAdvisor &&
    value <= restrictions.maxProductManager
  );
};

export const getDisabilityPaymentAfter3MonthsHint = (
  eligibleForPaymentAfter3Months: boolean,
  adviceProductIntroFormValues: AdviceProductDetailsFormValues,
  oneTimePayment: any,
  lang: string,
): string => {
  if (eligibleForPaymentAfter3Months) {
    if (
      adviceProductIntroFormValues.workSituation === WorkSituation.WORK_PRIVATE
    ) {
      return `${oneTimePayment.advisorTexts.workSituation.sharedInfo[lang]} ${oneTimePayment.advisorTexts.workSituation.workPrivateInfo[lang]}`;
    } else if (
      adviceProductIntroFormValues.workSituation === WorkSituation.SELF_EMPLOYED
    ) {
      return `${oneTimePayment.advisorTexts.workSituation.sharedInfo[lang]} ${oneTimePayment.advisorTexts.workSituation.selfEmployedInfo[lang]}`;
    }
  }
  return oneTimePayment.advisorTexts.workSituation.sharedInfo[lang];
};
